import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex-col justify-center items-center" }
const _hoisted_2 = { class: "rounded-full flex justify-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex justify-center mt-3" }
const _hoisted_5 = { class: "col-span-12 sm:col-span-12 lg:col-span-3 xl:col-span-3" }
const _hoisted_6 = { class: "flex flex-col justify-center items-center gap-5 sticky top-2" }
const _hoisted_7 = { class: "rounded-full flex justify-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "flex flex-col mt-3" }
const _hoisted_11 = {
  for: "file-input",
  class: "flex gap-2 cursor-pointer"
}
const _hoisted_12 = { class: "col-span-12 sm:col-span-12 lg:col-span-9 xl:col-span-9" }
const _hoisted_13 = { class: "md:ml-5" }
const _hoisted_14 = { class: "text-gray-600 mt-3" }
const _hoisted_15 = { class: "grid grid-cols-12 gap-5 mt-5" }
const _hoisted_16 = { class: "hidden" }
const _hoisted_17 = ["for"]
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            ref: "imgProfile",
            src: _ctx.previewFile || require('@/assets/images/user.svg'),
            alt: "preview-profile",
            class: "rounded-full w-72 h-72 object-center object-cover"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            icon: "pi pi-pencil",
            class: "btn-simple",
            label: "Editar",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal()))
          })
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
      closable: false,
      draggable: false,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '80vw' },
      modal: true,
      onHide: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeModal())),
      class: "dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancelar",
          class: "btn-outline p-button-sm",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeModal()))
        }),
        _createVNode(_component_Button, {
          label: "Salvar",
          class: "btn-primary p-button-sm",
          type: "submit",
          loading: _ctx.loading,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitFile()))
        }, null, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "grid grid-cols-12 gap-5 lg:divide-x-2 relative",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submitFile()), ["prevent"]))
        }, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("aside", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  ref: "imgChoose",
                  src: _ctx.previewFile || require('@/assets/images/user.svg'),
                  alt: "preview-profile",
                  class: "rounded-full w-72 h-72 object-cover"
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Foto de perfil",
                  en: "Profile photo",
                })), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("input", {
                  id: "file-input",
                  ref: "fileInput",
                  accept: "image/*",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadFile($event))),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputReset($event))),
                  type: "file",
                  hidden: ""
                }, null, 544),
                _createVNode(_component_Button, { class: "btn-outline p-button-sm" }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_11, [
                      _createVNode(_component_v_icon, { name: "hi-solid-pencil" }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Carregar foto",
                      en: "Load file",
                    })), 1)
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Selecionar avatar",
                  en: "Choose avatar",
                })), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("avatar.info")), 1),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAvatars, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: _normalizeClass(`col-span-3 w-full`)
                  }, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_RadioButton, {
                        name: "avatar",
                        inputId: item.id,
                        value: item,
                        modelValue: _ctx.selected,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected) = $event)),
                        onChange: _ctx.chooseAvatar
                      }, null, 8, ["inputId", "value", "modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(`w-full max-h-64 overflow-hidden rounded-full flex items-center ${
                    _ctx.selected?.id == item.id
                      ? 'border-4 md:border-8 border-h-secondary-700 ring-4 md:ring-8 ring-yellow-100 transition-all'
                      : ''
                  }`)
                    }, [
                      _createElementVNode("label", {
                        for: item.id
                      }, [
                        _createElementVNode("img", {
                          src: item.media?.path,
                          alt: `item-media`,
                          class: _normalizeClass(`object-cover rounded-full scale-125 cursor-pointer w-full h-full`)
                        }, null, 8, _hoisted_18)
                      ], 8, _hoisted_17)
                    ], 2)
                  ]))
                }), 128))
              ])
            ])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}